var DropdownLooks = /*#__PURE__*/ function(DropdownLooks) {
    DropdownLooks["Default"] = "default";
    DropdownLooks["Primary"] = "primary";
    return DropdownLooks;
}({});

export { DropdownLooks };
//# sourceMappingURL=dropdown.js.map
